export default __webpack_public_path__ + "static/media/happy.24a80f7a.png";